import get from "lodash/get";
import { DISCOUNT_TYPE_PACK } from "@/lib/amount.js";

export const getPackDiscounts = function(drug) {
  let discounts = get(drug, "price.discounts", null);
  if (!discounts || typeof discounts.filter != "function") {
    return [];
  }
  return discounts.filter(d => d.discount_type === DISCOUNT_TYPE_PACK);
};

export const isDrugsPack = function(drug) {
  return getPackDiscounts(drug).length > 0;
};

export const getPackQuantity = function(drug) {
  const [packDiscount] = getPackDiscounts(drug);
  return (packDiscount || {}).pack_quantity;
};

export const getDrugsQuantity = function(drugs) {
  // Devuelve la cantidad total de productos
  // contando también las unidades de los packs
  return drugs.reduce((total, drug) => {
    return total + drug.quantity * (getPackQuantity(drug) || 1);
  }, 0);
};

export const getPharmacyCategories = function(categories) {
  // Busca categorías con el campo pharmacy_category
  // Recorre todas las subcategorías
  let pharmacyCategories = [];
  categories.forEach(cat => {
    if (cat.pharmacy_category === true) {
      // Añadimos la categoría (no miramos las subcategorías)
      pharmacyCategories.push(cat);
    }
    else if (cat.subcategories.length > 0) {
      // Seguimos buscando por las subcategorías y concatenamos las categorías
      // que encontremos
      pharmacyCategories = pharmacyCategories.concat(
        getPharmacyCategories(cat.subcategories)
      );
    }
  });
  return pharmacyCategories;
};
